/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestMaxResultNotStartedSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('AUTO_TEST_MAX_RESULT_NOT_STARTED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(parsers.duration)],
]);
export class AutoTestMaxResultNotStartedSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestMaxResultNotStartedSettingParser.decode(input).map(res => new AutoTestMaxResultNotStartedSetting(res));
    }
    static unsafeDecode(input) {
        return AutoTestMaxResultNotStartedSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestMaxResultNotStartedSettingParser.encode(data);
    }
    static schema() {
        return AutoTestMaxResultNotStartedSettingParser.schema();
    }
}
